/** 図書館の受取期限 (YYYY-MM-DD) を M/D にする */
export const formatPickupDate = (ymd: string): string => {
  const [, month, day] = ymd.split('-')
  return `${Number(month)}/${Number(day)}`
}
